import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLang, useCart } from "../context";
import { http } from "../api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function CheckoutSuccess() {
  const { lang } = useLang();
  const { clearCart } = useCart();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const cleared = useRef(false);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 6) { setStatus("timeout"); return; }
      attempts++;
      try {
        const { data } = await http.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          if (!cleared.current) { clearCart(); cleared.current = true; }
          setStatus("paid");
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(poll, 2000);
      } catch { setTimeout(poll, 2000); }
    };
    poll();
  }, [params, clearCart]);

  const M = {
    checking: { fr: "Vérification du paiement…", en: "Verifying payment…" },
    paid: { fr: "Paiement confirmé. Merci pour votre commande !", en: "Payment confirmed. Thank you for your order!" },
    timeout: { fr: "Paiement en cours de traitement. Vérifiez vos courriels.", en: "Payment processing. Please check your email." },
    expired: { fr: "La session a expiré. Veuillez réessayer.", en: "Session expired. Please try again." },
    error: { fr: "Aucune session de paiement trouvée.", en: "No payment session found." },
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="checkout-result">
      <div className="flex justify-center mb-6">
        {status === "checking" && <Loader2 size={48} className="animate-spin text-[#737373]" strokeWidth={1.2} />}
        {status === "paid" && <CheckCircle2 size={48} className="text-[#1A1A1A]" strokeWidth={1.2} />}
        {["timeout", "expired", "error"].includes(status) && <XCircle size={48} className="text-[#737373]" strokeWidth={1.2} />}
      </div>
      <h1 className="serif text-4xl mb-4" data-testid="checkout-status">{M[status][lang]}</h1>
      <Link to="/shop" className="inline-block mt-6 bg-[#1A1A1A] text-[#F9F8F6] px-7 py-3.5 text-sm uppercase tracking-widest rounded-sm">
        {lang === "fr" ? "Continuer mes achats" : "Continue shopping"}
      </Link>
    </div>
  );
}
